import { ChangeEventHandler } from 'react';

import CheckIcon from '@/assets/icons/icon-check-small.svg';

interface ICheckboxButtonProps {
  value?: boolean;
  onSwitch: ChangeEventHandler<HTMLInputElement>;
}

const CheckboxButton: React.FC<ICheckboxButtonProps> = ({ value, onSwitch }) => {
  return (
    <label className='size-4 relative'>
      <input
        type='checkbox'
        className='peer sr-only'
        checked={value}
        onChange={(e) => {
          e.stopPropagation();
          onSwitch(e);
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className='peer-checked:!bg-primary dark:peer-checked:!bg-primary dark:!bg-white peer size-4 bg-white rounded-sm border-2 border-black peer-checked:border-primary flex items-center justify-center'
      >
        <CheckIcon className='[&_path]:!fill-white' />
      </div>
    </label>
  );
};

export default CheckboxButton;
